import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from 'moment';
import TouristAppointmentsApi from "../../../services/TouristAppointmentsApi";
import { Wrapper } from "../../../mainComponent/Wrapper";
import { MainNav } from "../../../mainComponent/mainNav";
import UserLinks from "../partial/uselinks";
import { setHelperData } from '../../../recoil/atom/setHelperData';
import { useRecoilState } from "recoil";
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";

export default function TouristAppointmentView() {
    const { doctorId, touristId } = useParams();
    const [helpersData, setHelpersData] = useRecoilState(setHelperData);
    const { getTouristAppointmnetById, updateTouristActivitiesById } = TouristAppointmentsApi();
    const [data, setData] = useState([]);
    const [packageActivities, setPackageActivities] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        getTouristData();
    }, []);

    const getTouristData = () => {
        getTouristAppointmnetById(touristId)
            .then((res) => {
                setData(res);
                if (res.packageActivities) {
                    setPackageActivities(res.packageActivities);
                }
            });
    };

    const handleDetailChange = (activityIndex, key, event) => {
        const newPackageActivities = [...packageActivities];
        if (newPackageActivities[activityIndex]) {
            if (newPackageActivities[activityIndex].activities[0].details) {
                newPackageActivities[activityIndex].activities[0].details[key] = event.target.value;
                setPackageActivities(newPackageActivities);
            }
        }
    };

    const updateActivityChange = () => {
        const bodyData = {
            packageActivities: packageActivities,
            startDate: data.startDate,
            touristName: data.touristName,
            packageName: data.packageName,
            touristEmail: data.touristEmail,
            packageDuration: data.packageDuration,
            endDate: data.endDate,
            packagePrice: data.packagePrice,
            doctorId: doctorId,
            touristId: touristId,
        };
        updateTouristActivitiesById(touristId, bodyData)
            .then((res) => {
                alert("Activities Updated Successfully");
                navigate(`/tourism/${doctorId}`);
            });
    }

    return (
        <Wrapper>
            <MainNav>
                <div className="clearfix row">
                    <div className="width50">
                        <ul className="clearfix">
                            <li className='float-none' style={{ fontSize: 'inherit' }}>
                                Tourist Appointment Details
                            </li>
                        </ul>
                    </div>
                </div>
            </MainNav>

            <div className="row">
                <div className='width_16'>
                    <div className='dash row'>
                        <UserLinks
                            doctorId={doctorId}
                            helperId={helpersData._id}
                            accessModule={helpersData.access_module}
                        />
                    </div>
                </div>

                <div className='width_84 common_box'>
                    <div className='white-box'>
                        <div className='p-2'>
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className="patientDataStyle">
                                        {[
                                            ['Package Name', data.packageName],
                                            ['Package Duration', data.packageDuration],
                                            ['Package Plan', data.packagePrice],
                                            ['Tourist Name', data.touristName],
                                            ['Tourist City', data.touristCity],
                                            ['Tourist Country', data.touristCountry],
                                            ['Tourist Email', data.touristEmail],
                                            ['Tourist Mobile', data.touristMobile],
                                            ['Journey - Start Date', moment(data.startDate).format("DD-MM-YYYY")],
                                            ['Journey - End Date', moment(data.endDate).format("DD-MM-YYYY")],
                                            ['Message', data.message]
                                        ].map(([label, value], i) => (
                                            <div className="row" key={i}>
                                                <div className="width30">
                                                    <label className="font_weight mx-2">{label}</label>
                                                </div>
                                                <div className="width70">
                                                    {value}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <label className="font_weight mx-2">Update Traveling Details</label>
                                    {packageActivities && packageActivities.length > 0 ? (
                                        packageActivities.map((packageActivity, index) => {
                                            const activityObj = packageActivity.activities[0] || {};
                                            const details = activityObj.details || {};

                                            return (
                                                <div className="helperDiv" key={index}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMore />}
                                                            aria-controls={`panel-content-${index}`}
                                                            id={`panel-header-${index}`}
                                                        >
                                                            {activityObj.activity || `Activity ${index + 1}`}
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <div className="mb-3">
                                                                <label className="helperLabel font_weight float-left">Activity Name</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={activityObj.activity || ""}
                                                                />
                                                            </div>

                                                            {details && Object.entries(details).map(([key, value]) => (
                                                                <div className="mb-2" key={key}>
                                                                    <label className="helperLabel float-left">
                                                                        {key.replace(/_/g, ' ')}:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={value}
                                                                        onChange={(e) => handleDetailChange(index, key, e)}
                                                                        placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <p>No activities found.</p>
                                    )}
                                </div>
                            </div>
                            <MainButtonInput onClick={updateActivityChange}>Save Changes</MainButtonInput>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
}